import { gql } from '@apollo/client'

export default gql(`
    query exportCsv($key: String, $project:String){
        exportCsv(key : $key project: $project) {
            bucket
            key
            region
            url
            uploadUrl
        }
    }`
)
